import script from "./DynamicPaymentMethodSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicPaymentMethodSelection.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicPaymentMethodSelection.vue?vue&type=style&index=0&id=2f4bdef2&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f4bdef2"]])

export default __exports__